<template>
    <router-link :to="to" class="d-flex justify-content-between align-items-center w-100 px-3">
        <fa-icon :icon="['fal', icon]"></fa-icon>
        <span><slot></slot></span>
    </router-link>
</template>

<script>
export default {
  name: 'NavItem',
  props: ['to', 'icon']
}
</script>
